import type { HtmlHTMLAttributes } from 'react'
import { cn } from '@/utils/cn'

interface TextSeparatorProps extends HtmlHTMLAttributes<HTMLDivElement> {
  text: string
}
export function TextSeparator({ text, className, ...props }: TextSeparatorProps) {
  return (
    <div className={cn('relative flex items-center justify-between', className)} {...props}>
      <div className="h-px flex-1 bg-sidebar-border" />
      <div className="mx-2 text-muted-foreground text-xs">{text}</div>
      <div className="h-px flex-1 bg-sidebar-border" />
    </div>
  )
}
